export const setAuthHeader = () => {
  const profile = localStorage.getItem('pxmusic_admin')
  if (profile) {
    const { token } = JSON.parse(profile)
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }
  return {
    'Content-Type': 'application/json',
  }
}

export const authRequest = (url, options) => {
  const requestOptions = {
    // method: 'POST',
    headers: setAuthHeader(),
    ...options,
  }

  return fetch(url, requestOptions).then(handleResponse)
}

export const handleResponse = async (response) => {
  const contentType = response.headers.get('content-type')
  const isJson = contentType && contentType.indexOf('application/json') !== -1
  try {
    if (!response.ok) {
      throw isJson ? await response.json() : await response.text()
    } else {
      return await response.json()
    }
  } catch (err) {
    throw err
  }
}
